@switch (showOpenRegistration$ | async) {
  @case (true) {
    <app-open-registration></app-open-registration>
  }
  @case (false) {
    <app-registration-list></app-registration-list>
  }
  @default {
    <div class="registration-list-route__spinner">
      <se-fe-spinner [seFeDataCenter]="true" [seFeDataSize]="900"></se-fe-spinner>
    </div>
  }
}
